import React from 'react'

function Divider({ className }) {
	return (
		<div className={`dark:bg-gray-200 bg-gray-300  h-[1px] w-full ${className}`} />
	)
}

export default Divider